import { Circle as CircleStyle, Fill, Stroke, Style, Text, Icon } from 'ol/style';

const patternCanvas = document.createElement('canvas');
const patternContext = patternCanvas.getContext('2d');
 
// Streifen für "angeschnittenes" Teileinzugsgebiet
patternCanvas.width = 50;
patternCanvas.height = 50;
//patternContext.fillStyle = 'rgba(255,255,255,0.7)';
//patternContext.fillRect(0, 0, patternCanvas.width, patternCanvas.height);
patternContext.beginPath();
patternContext.strokeStyle = 'rgba(255,255,255,0.8)';
patternContext.lineWidth = 10;
patternContext.moveTo(0, 0);
patternContext.lineTo(patternCanvas.width, patternCanvas.height);
patternContext.stroke();
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
const pattern = ctx.createPattern(patternCanvas, 'repeat');

export function setBauwerkStyle(feature) {
  let typ = feature.get("ID_TE_Typ");
  if (typ?.includes("Speicher"))
    return speicherStyle;
  else if(typ === "Kläranlage")
    return klaeranlageStyle;
  else if(typ?.includes("Abzweig"))
    return abzweigStyle;
}

export function setBauwerkSelectStyle(feature) {
  let typ = feature.get("ID_TE_Typ");
  if (typ?.includes("Speicher"))
    return speicherSelectStyle;
  else if(typ === "Kläranlage")
    return klaeranlageSelectStyle;
  else if(typ?.includes("Abzweig"))
    return abzweigSelectStyle;
}

export function setKfStyle(feature) {
  if (feature.get('ID_TGQTMode') === "Trennsystem") {
    return kfTrennStyle;
  } else if (feature.get('ID_TGQTMode') === "Mischsystem") {
    return kfMischStyle;
  } else {
    return kfUngesetztStyle;
  }
}

export function setKfSelectStyle(feature) {
  if (feature.get('ID_TGQTMode') === "Trennsystem") {
    return kfTrennSelectStyle;
  } else if (feature.get('ID_TGQTMode') === "Mischsystem") {
    return kfMischSelectStyle;
  } else {
    return kfUngesetztSelectStyle;
  }
}
 

export let tgStyle : Style = new Style({
  stroke: new Stroke({
    color: 'red',
    width: 2
  }),
  fill: new Fill({
    color: 'rgba(255,255,255, 0.0)'
  })
});

export let teStyle : Style = new Style({
  stroke: new Stroke({
    color: 'blue',
    width: 4
  })
});

export let kfTrennStyle : Style = new Style({
  stroke: new Stroke({
    color: 'white',
    width: 1
  }),
  fill: new Fill({
    color: 'rgba(128, 212, 255, 0.6)'
  })
});

export let kfTrennSelectStyle : Style = new Style({
  stroke: new Stroke({
    color: 'white',
    width: 3
  }),
  fill: new Fill({
    color: 'rgba(128, 212, 255, 0.9)'
  })
});

export let kfMischStyle : Style = new Style({
  stroke: new Stroke({
    color: 'white',
    width: 1
  }),
  fill: new Fill({
    color: 'rgba(255, 153, 187, 0.6)'
  })
});

export let kfMischSelectStyle : Style = new Style({
  stroke: new Stroke({
    color: 'white',
    width: 3
  }),
  fill: new Fill({
    color: 'rgba(255, 153, 187, 0.9)'
  })
});

export let kfUngesetztStyle : Style = new Style({
  stroke: new Stroke({
    color: 'white',
    width: 1
  }),
  fill: new Fill({
    color: 'rgb(211, 211, 211, 0.6)'
  })
});

export let kfUngesetztSelectStyle : Style = new Style({
  stroke: new Stroke({
    color: 'white',
    width: 3
  }),
  fill: new Fill({
    color: 'rgba(211, 211, 211, 0.9)'
  })
});

export const tgSelectStyle = new Style({
  fill: new Fill({
    color: 'rgba(255,255,255,0.7)',
  }),
  stroke: new Stroke({
    color: 'red',
    width: 4,
  })
});

export const tgHalfSelectStyle = new Style({
  fill: new Fill({
    color: pattern,
  }),
  stroke: new Stroke({
    color: 'red',
    width: 4,
  })
});

export let teSelectStyle : Style = new Style({
  stroke: new Stroke({
    color: 'blue',
    width: 10
  })
});

export let speicherStyle = new Style({
  image: new Icon({
    src: 'icon/speicher.svg',
    scale: 1
  })
});

export let speicherSelectStyle = new Style({
  image: new Icon({
    src: 'icon/speicherSelect.svg',
    scale: 1.3
  })
});

export let klaeranlageStyle = new Style({
  image: new Icon({
    src: 'icon/ka.svg',
    scale: 0.7
  })
});

export let klaeranlageSelectStyle = new Style({
  image: new Icon({
    src: 'icon/kaSelect.svg',
    scale: 1
  })
});

export let abzweigStyle = new Style({
  image: new Icon({
    src: 'icon/vz.svg',
    scale: 0.7
  })
});

export let abzweigSelectStyle = new Style({
  image: new Icon({
    src: 'icon/vzSelect.svg',
    scale: 1
  })
});

export let gwStyle : Style = new Style({
  stroke: new Stroke({
    color: 'blue',
    width: 1
  })
});


export let gwSelectStyle : Style = new Style({
  stroke: new Stroke({
    color: 'aqua',
    width: 5
  })
});

export let hoverMarkerStyle = new Style({
  image: new CircleStyle({
    radius: 10,
    stroke: new Stroke({
      color: 'rgb(255, 0, 0)',
      width: 3
    }),
    fill: new Fill({
      color: 'rgba(255, 251, 0, 0.5)'
    })
  })
});

export let systemPlanStyleHaupt = new Style({
  stroke: new Stroke({
    color: 'black',
    width: 2
  })
})

export let systemPlanStyleNeben = new Style({
  stroke: new Stroke({
    color: 'black',
    width: 2,
    lineDash: [.1, 5]
  })
})